<script>
    export default {
        name: 'AtMemberName',
        props: {
            member: {
                type: Object,
                default: () => {}
            }
        }
    }
</script>

<template>
    <router-link v-if="member.id" class="member-name" :to="`/ast/members/${member.id}`">
        <span v-if="member.mark_name">{{ member.mark_name }}</span>
        <template v-else>
            <template v-if="member.name.length > 6">
                <a-popover>
                    <template slot="content">
                        {{ member.name }}
                    </template>
                    {{ member.name.substring(0, 6) }}
                </a-popover>
            </template>
            <template v-else>
                <span>{{ member.name }}</span>
            </template>
        </template>
    </router-link>
</template>

<style scoped lang="less">

</style>